module.exports = __webpack_public_path__ + "img/banner-hand.2feeaa41.png";